var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20H14C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9995 2C11.4472 2 10.9995 2.44772 10.9995 3V4C10.9995 4.02775 11.0006 4.05523 11.0029 4.08241C8.16352 4.55712 5.99956 7.02585 5.99956 10V11.9574C5.99956 12.3881 5.84364 12.8042 5.56063 13.1289L4.91619 13.8682C2.82937 16.2623 4.5297 20 7.7056 20H16.2935C19.4694 20 21.1697 16.2623 19.0829 13.8682L18.4385 13.1289C18.1555 12.8042 17.9996 12.3881 17.9996 11.9574V10C17.9996 7.02582 15.8355 4.55707 12.9962 4.08239C12.9984 4.05522 12.9995 4.02774 12.9995 4V3C12.9995 2.44772 12.5518 2 11.9995 2ZM7.99956 10C7.99956 7.79086 9.79042 6 11.9996 6C14.2087 6 15.9996 7.79086 15.9996 10V11.9574C15.9996 12.8712 16.3304 13.7542 16.9308 14.443L17.5753 15.1824C18.5342 16.2825 17.7529 18 16.2935 18H7.7056C6.24623 18 5.46491 16.2825 6.42383 15.1824L7.06827 14.443C7.66875 13.7542 7.99956 12.8712 7.99956 11.9574V10Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.9316fe2ee4b550ab6b7473be15967341.svg";
export { ForwardRef as ReactComponent };